import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import adminFundValidation from '../../../../validations/admin/fund';

export default Route.extend({
  abilities: service(),
  navbarSettings: service(),

  beforeModel(transition) {
    if (this.abilities.noAbility('admin_edit_funds')) {
      transition.abort();
      return;
    }
    set(this, 'navbarSettings.title', 'Edit Fund');
  },

  model() {
    let parentModel = this.modelFor('admin.funds.fund');
    let changeset = new Changeset(
      get(parentModel, 'record'),
      lookupValidator(adminFundValidation),
      adminFundValidation,
    );
    return {
      record: get(parentModel, 'record'),
      changeset: changeset,
    };
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
